import * as React from 'react';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import { Check, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ children, className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'group/checkbox peer size-4.5 shrink-0 rounded-sm border-0 shadow-none ring-1 ring-ui-bevel transition duration-150 focus-within:ring-2 focus-visible:outline-hidden focus-visible:ring-ui-separator focus-visible:ring-offset-0 focus-visible:duration-150 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-red-500! aria-invalid:focus-within:ring-red-500!',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      {children ?? (
        <>
          <Check className="-mt-px hidden icon-2.5 group-data-[state=checked]/checkbox:block" strokeWidth={5} />
          <Minus className="hidden icon-4 group-data-[state=indeterminate]/checkbox:block" strokeWidth={2} />
        </>
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
